module.exports = __webpack_public_path__ + "static/media/selected_pin.f1297dd1.png";